var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.154,
    height: 24.633,
    viewBox: "0 0 20.154 24.633",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file-text",
    transform: "translate(-4.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    d: "M7.859,1.5h8.957a1.12,1.12,0,0,1,.792.328l6.718,6.718a1.12,1.12,0,0,1,.328.792V22.774A3.363,3.363,0,0,1,21.3,26.133H7.859A3.363,3.363,0,0,1,4.5,22.774V4.859A3.363,3.363,0,0,1,7.859,1.5Zm8.494,2.239H7.859a1.121,1.121,0,0,0-1.12,1.12V22.774a1.121,1.121,0,0,0,1.12,1.12H21.3a1.121,1.121,0,0,0,1.12-1.12V9.8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    d: "M27.338,10.457H20.62a1.12,1.12,0,0,1-1.12-1.12V2.62a1.12,1.12,0,1,1,2.239,0v5.6h5.6a1.12,1.12,0,0,1,0,2.239Z",
    transform: "translate(-3.803 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    d: "M20.577,20.239H11.62a1.12,1.12,0,1,1,0-2.239h8.957a1.12,1.12,0,1,1,0,2.239Z",
    transform: "translate(-1.521 -4.184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    d: "M20.577,26.239H11.62a1.12,1.12,0,0,1,0-2.239h8.957a1.12,1.12,0,1,1,0,2.239Z",
    transform: "translate(-1.521 -5.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    d: "M13.859,14.239H11.62a1.12,1.12,0,1,1,0-2.239h2.239a1.12,1.12,0,1,1,0,2.239Z",
    transform: "translate(-1.521 -2.662)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.3944da3c81a6e3700bff37ad129870b8.svg";
export { ForwardRef as ReactComponent };